import React, { useCallback, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import useTranslation from '../../../hooks/useTranslation';
import { userInfoStore } from '../../../store/userInfoStore';
import { parseQuery } from '../../../core/helpers/parseQuery';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { DefaultQueryParams } from '../../../core/constants/defaultQueryParams';
import { BetHistoryColumnByGame } from '../../../core/constants/betHistoryColumnByGame';
import { checkScrollToBottom } from '../../../core/helpers/checkScrollToBottom';
import { isMobile } from '../../../core/helpers/isMobile';
import Table from '../../../components/table';

const BetHistory = observer(() => {
  const {
    betHistory: { data: betHistory },
  } = betHistoryStore;
  const { rate, precision, userId, currencyCode } = userInfoStore;
  const { search } = useLocation();
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(search);
  const t = useTranslation();

  const gameBetHistoryColumn = useMemo(() => {
    return BetHistoryColumnByGame[gameId];
  }, [gameId]);

  const handleScroll = useCallback((e) => {
    if (checkScrollToBottom(e)) {
      betHistoryStore.getBetHistory();
    }
  }, []);

  useEffect(() => {
    document
      .querySelector(isMobile() ? '#root' : '.cpt-wrapper-inner')
      .addEventListener('scroll', handleScroll);
    betHistoryStore.getBetHistory();
    return () => {
      document
        .querySelector(isMobile() ? '#root' : '.cpt-wrapper-inner')
        .removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    return () => {
      betHistoryStore.resetBetHistory();
    };
  }, []);

  return (
    <Table
      t={t}
      rate={rate}
      data={betHistory}
      precision={precision}
      currentUserId={userId}
      currency={currencyCode}
      columns={gameBetHistoryColumn}
    />
  );
});
export default BetHistory;
